
import "./schedule.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef} from "react";
import React from "react";
import { useForm } from "react-hook-form";

/* banco de dados */
import { db, auth } from "../../services/firebaseConnection";
import { getDoc, doc, collection, query, where, orderBy, getDocs, onSnapshot, updateDoc, deleteField, addDoc, serverTimestamp, limit, Timestamp, writeBatch } from "firebase/firestore";

/* funções auxiliares */
import { db_basic, wait, showError, clearError, formError, registerLog, direcionaPlano } from "../../services/functions/functions.ts";

/* validação de campos */
import { masktelefone } from "../../services/masks/masks.ts";

/* links */
import { Link, useNavigate } from "react-router-dom";

/* ícones */
import { CalendarCheck, CalendarClock, CalendarX, CalendarSync, ArrowBigRightDash, ArrowBigLeftDash, ClockArrowUp } from "lucide-react";

/* calendário */
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { ptBR } from "date-fns/locale";



export default function Schedule() {

    const [basic, setBasic] = useState([]);
    const [error, setError] = useState("0");
    const [mondayBase, setMondayBase] = useState(normalizeMonday(getWeekRange().monday));
    const [mondayStart, setMondayStart] = useState(null);
    const [mondayEnd, setMondayEnd] = useState(null);

    const [semana, setSemana] = useState([]);
    const [hoverAgendamento, setHoverAgendamento] = useState(null);
    const [intervalSemana, setIntervalSemana] = useState(60);

    const [isUpdating, setIsUpdating] = useState(false);
    const [erroAcao, setErroAcao] = useState("");
    const [erroNavegar, setErroNavegar] = useState("");

    const navigate = useNavigate();

    const HORAS_UI = gerarHorasUI(intervalSemana);

    const tooltipRef = useRef(null);

    const [isPending, startTransition] = useTransition();

    const HORAS = Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, "0")}:00`);

    const isFirstWeek = mondayStart && mondayBase.getTime() <= mondayStart.getTime();
    const isLastWeek =  mondayEnd && mondayBase.getTime() >= mondayEnd.getTime();

    const [selectedSlot, setSelectedSlot] = useState(null);
    // formato: { diaId: "20260413", hora: "08:00" }

    const [reagendamento, setReagendamento] = useState(null);

    // calendário
    const [selectedDate, setSelectedDate] = useState(null);

    const [showCreateModal, setShowCreateModal] = useState(false);
    const [configModal, setConfigModal] = useState({exames: [], convenios: []});
    const [atendimento, setAtendimento] = useState("consulta");
    const [novoAgendamento, setNovoAgendamento] = useState({nome: "", email: "", telefone: "", atendimento: "consulta", convenio: "", exame: ""});

    const datePickerRef = useRef(null);

    const refNome = useRef(null);
    const refLabelNome = useRef(null);
    const refErrorNome = useRef(null);

    const refEmail = useRef(null);
    const refLabelEmail = useRef(null);
    const refErrorEmail = useRef(null);

    const refTelefone = useRef(null);
    const refLabelTelefone = useRef(null);
    const refErrorTelefone = useRef(null);

    const refNomePet = useRef(null);
    const refLabelNomePet = useRef(null);
    const refErrorNomePet = useRef(null);

    const refError = useRef(null);

    const openedAt = useRef(Timestamp.now());

    const { handleSubmit, register, getValues, setValue, watch } = useForm();

    const handleChange = (event) => { setAtendimento(event.target.value); setNovoAgendamento(prev => ({ ...prev, atendimento: event.target.value})) };

    function getWeekRange(date = new Date()) {
    
        const day = date.getDay(); // 0 = domingo, 1 = segunda ...

        const monday = new Date(date);
        monday.setDate(date.getDate() - ((day + 6) % 7));

        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);

        return {monday, sunday};
    }

 
    function formatToFirestoreDate(date) {
        return date.toISOString().slice(0,10).replace(/-/g,"");
    }

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        const loadBasic = async () => {
            
            const uid = auth.currentUser.uid;
            const bbd = await db_basic(uid);
            setBasic(bbd);
        
            //carrega informações
            try {

                registerLog(uid, "/page/schedulle");

            } catch(erro) {

            }
        
        };

        loadBasic();

    }, []);


    useEffect(() => {if(!basic.agent?.id) return; carregarSemana(mondayBase)}, [mondayBase, basic.agent?.id]);


    // snapshot para aparecer o agendamento
    useEffect(() => {
    
        if(!mondayBase || !basic.agent?.id) return;

        const diasSemanaIds = [];
        for(let i = 0; i < 7; i++) {
            const d = new Date(mondayBase);
            d.setDate(mondayBase.getDate() + i);
            diasSemanaIds.push(formatToFirestoreDate(d));
        }

        const aid = basic.agent.id;

        const logsRef = collection(db, "ls_calendar");
        const q = query(logsRef, where("id_agent", "==", aid), orderBy("date", "desc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {

            snapshot.docChanges().forEach(change => {

            if(change.type !== "added") return;

            //proteção: pode vir change.doc undefined
            if(!change.doc || !change.doc.exists()) {
                console.warn("change.doc inexistente — ignorado");
                return;
            }

            const log = change.doc.data();

            let firestoreDia = log.dia;
            const hora = log.hora;
            const action = log.action;

            // normaliza o dia para YYYYMMDD
            if(firestoreDia.includes("-")) {
                firestoreDia = firestoreDia.replace(/-/g, "");
            } else if(firestoreDia.includes("/")) {
                const [dd, mm, yyyy] = firestoreDia.split("/");
                firestoreDia = `${yyyy}${mm.padStart(2, "0")}${dd.padStart(2, "0")}`;
            }

            if(!diasSemanaIds.includes(firestoreDia)) return;

            setSemana(prev => {
                
                const dias = [...prev];
                const idx = dias.findIndex(d => d.firestoreId === firestoreDia);
                
                if(idx === -1) return prev;

                const dia = {...dias[idx]};
                const horas = {...dia.horas};

                if(!horas[hora]) {
                    horas[hora] = { status: "nao_determinado" };
                }

                if(action === "ADD") {
                    horas[hora] = {
                        status: "ocupado",
                        paciente: {nome: log.nome || null, email: log.email || null, telefone: log.telefone || null, atendimento: log.atendimento || "", convenio: log.convenio || ""}
                    };
                }

                if(action === "CANCEL") {
                    horas[hora] = { status: "livre" };
                }

                dia.horas = horas;
                dias[idx] = dia;

                return dias;
                
            });

            });
        });

        return () => unsubscribe();

    }, [mondayBase, basic.agent?.id]);



    // snapshot para a confirmação de agendamento
    useEffect(() => {

        if(!basic.agent?.id) return;

        // escuta somente mensagens criadas após abrir a agenda
        const q = query(collection(db, "ls_map_whatsapp"), where("update_at", ">=", openedAt.current));

        const unsubscribe1 = onSnapshot(q, (snapshot) => { console.log(snapshot.docs.map(doc => doc.data())); });
        console.log(openedAt.current.toDate());

        const unsubscribe = onSnapshot(q, (snapshot) => {

            snapshot.docChanges().forEach(change => {

                const data = change.doc.data();

                // ainda aguardando resposta
                if(data.status !== "confirmado" && data.status !== "nao_poderei_ir") {
                    return;
                }

                const correlation = data.correlation_id;

                if(!correlation) return;

                const [idAgent, firestoreDia, horaSemPontos] = correlation.split("_");

                // não é deste agente
                if(idAgent !== basic.agent.id) return;

                const hora = horaSemPontos.substring(0, 2) + ":" + horaSemPontos.substring(2, 4);

                setSemana(prev => {

                    const indiceDia = prev.findIndex(d => d.firestoreId === firestoreDia);

                    // não faz parte da semana aberta
                    if(indiceDia === -1) return prev;

                    const slot = prev[indiceDia].horas[hora];

                    // horário inexistente
                    if(!slot) return prev;

                    // não é um horário ocupado
                    if(slot.status !== "ocupado") return prev;

                    // paciente inexistente
                    if(!slot.paciente) return prev;

                    const novaSemana = [...prev];

                    novaSemana[indiceDia] = {...novaSemana[indiceDia], horas: {...novaSemana[indiceDia].horas, [hora]: {...slot, paciente: {...slot.paciente, confirmacao: data.status === "confirmado"}}}};

                    return novaSemana;

                });

            });

        });

        return () => unsubscribe();

    }, [basic.agent?.id]);




    async function carregarSemana(mondayRef) {

        startTransition( async() => {

        try {

            let aid = basic.agent.id;
            let diasSemana = [];

            const calendarRef = doc(db, "db_calendar", aid);
            const calendarSnap = await getDoc(calendarRef);

            if(!calendarSnap.exists()) {
                throw new Error("Calendário não encontrado");
            }

            const interval = Number(calendarSnap.data().intervalo) || 60;

            setIntervalSemana(interval);

            const HORAS_SEMANA = gerarHorasUI(interval);

            // busca a primeira e última semana REAL do calendário
            const diasRef = collection(db, "db_calendar", aid, "dias");
            const diasSnap = await getDocs(diasRef);

            const mondaySet = new Set();

            diasSnap.forEach(docSnap => {
                const date = firestoreIdToDate(docSnap.id); // YYYYMMDD → Date
                const monday = normalizeMonday(getMonday(date));
                mondaySet.add(formatToFirestoreDate(monday));
            });

            if(mondaySet.size === 0) {
                throw new Error("Nenhuma semana encontrada no calendário");
            }

            const mondays = Array.from(mondaySet).sort(); // string YYYYMMDD

            const firstMonday = firestoreIdToDate(mondays[0]);
            const lastMonday  = firestoreIdToDate(mondays[mondays.length - 1]);

            setMondayStart(firstMonday);
            setMondayEnd(lastMonday);

            // loop normal da semana
            for(let i = 0; i < 7; i++) {

                const d = new Date(mondayRef);
                d.setDate(mondayRef.getDate() + i);

                const firestoreId = formatToFirestoreDate(d);
                const ref = doc(db, "db_calendar", aid, "dias", firestoreId);
                const snap = await getDoc(ref);

                let horas = {};

                if(!snap.exists()) {

                    HORAS_SEMANA.forEach(h => {horas[h] = { status: "nao_determinado" };});

                } else {

                    const horariosDb = snap.data();

                    HORAS_SEMANA.forEach(h => {

                    if(!horariosDb[h]) {
                        horas[h] = { status: "nao_determinado" };
                        return;
                    }

                    const item = horariosDb[h];

                    if(item.status === "livre") {
                        horas[h] = { status: "livre" };
                        return;
                    }

                    if(item.status === "ocupado") {
                        horas[h] = {status: "ocupado", paciente: item.paciente || null};
                        return;
                    }

                    horas[h] = { status: "nao_determinado" };
                    });

                }

                const dia_formatado = firestoreId.substring(6, 8) + "." + firestoreId.substring(4, 6) + "." + firestoreId.substring(0, 4);

                diasSemana.push({firestoreId, dia: dia_formatado, date: d, weekday: d.toLocaleDateString("pt-BR", { weekday: "long" }).replace("-feira", "").trim().replace(/^\w/, c => c.toUpperCase()), horas});
            }

            setSemana(diasSemana);
            
        }
        catch(erro) {
            console.log(erro);
        }
        })

    }


    function getMonday(date) {
    
        const d = new Date(date);
        const day = d.getDay(); // 0 = domingo
        const diff = d.getDate() - day + (day === 0 ? -6 : 1);
        d.setDate(diff);
        d.setHours(0, 0, 0, 0);
        return d;

    }


    function normalizeMonday(date) {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    }


    function firestoreIdToDate(id) {
        return new Date(id.substring(0, 4), Number(id.substring(4, 6)) - 1, id.substring(6, 8));
    }


    function proximaSemana() {

        if(isLastWeek) return;

        setSelectedSlot(null);

        const nova = new Date(mondayBase);
        nova.setDate(nova.getDate() + 7);
        setMondayBase(normalizeMonday(nova));

    }


    function semanaAnterior() {

        if(isFirstWeek) return;

        setSelectedSlot(null);
    
        const nova = new Date(mondayBase);
        nova.setDate(nova.getDate() - 7);
        setMondayBase(normalizeMonday(nova));
    
    }



    function buscarDia(date) {

        if(!date) return;

        setSelectedDate(date);

        // zera horário
        const d = new Date(date);
        d.setHours(0,0,0,0);

        // acha segunda-feira da semana
        const monday = getMonday(d);

        // navega agenda
        setMondayBase(normalizeMonday(monday));

        // limpa erros
        setErroNavegar("");

    }


    function TooltipAgendamento({data, tooltipRef}) {

        const [pos, setPos] = React.useState({ top: 0, left: 0 });
        const plano = basic.agent.plano.slice(0, 3);

        React.useLayoutEffect(() => {
            if(!tooltipRef.current || !data?.rect) return;

            const tooltipWidth = tooltipRef.current.offsetWidth;
            const spacing = 8;

            const left = data.lado === "left" ? data.rect.left - tooltipWidth - spacing : data.rect.right + spacing;

            setPos({ top: data.rect.top, left });

        }, [data, tooltipRef]);

        if(!data?.paciente) return null;

        return (
            <div ref={tooltipRef} className="tooltip-agendamento" style={{ top: pos.top, left: pos.left }}>

                {/* tooltip para médicos */}
                { plano === "CMD" && (
                <>
                {data.paciente?.atendimento && (<div className="agenda-tooltip-atendimento" style={{backgroundColor: data.paciente.atendimento.toUpperCase() === "CONSULTA" ? "blue" : data.paciente.atendimento.toUpperCase() === "RETORNO" ? "purple" : "green"}}>{ data.paciente.atendimento.toUpperCase() === "CONSULTA" || data.paciente.atendimento.toUpperCase() === "RETORNO" ? data.paciente.atendimento.toUpperCase() : (<>EXAME:<br />{data.paciente.atendimento}</>) }</div>)}
                <span className="agenda-tooltip-space"></span>
                {data.paciente?.convenio && (<div className="tooltip-linha">{data.paciente.atendimento === "retorno" ? "" : data.paciente.convenio === "particular" ? "Particular" : "Convênio: " + data.paciente.convenio}</div>)}
                <span className="agenda-tooltip-space"></span>
                <strong>{data.paciente?.nome || "Paciente"}</strong>
                <div className="tooltip-linha">📅 {data.dia} — {data.hora}</div>
                {data.paciente?.email && (<div className="tooltip-linha">✉️ {data.paciente.email}</div>)}
                {data.paciente?.telefone && (<div className="tooltip-linha">📞 {formatPhone(data.paciente.telefone)}</div>)}
                </>
                )}

                {/* tooltip para dentistas */}
                { plano === "DET" && (
                <>
                <div className="agenda-tooltip-atendimento" style={{backgroundColor: "blue"}}>CONSULTA</div>
                <br />
                {data.paciente?.atendimento.toUpperCase() !== "CONSULTA" && (<><span className="tooltip-linha">{data.paciente?.atendimento}</span><br /><br /></>)}
                <strong>{data.paciente?.nome || "Paciente"}</strong>
                <div className="tooltip-linha">📅 {data.dia} — {data.hora}</div>
                {data.paciente?.email && (<div className="tooltip-linha">✉️ {data.paciente.email}</div>)}
                {data.paciente?.telefone && (<div className="tooltip-linha">📞 {formatPhone(data.paciente.telefone)}</div>)}
                </>
                )}

            </div>
        );
    }



    function selecionarSlot(diaId, hora) {

        // limpa mensagens
        setErroAcao("");

        // seleção do slot
        setSelectedSlot(prev => {

            // clicou no mesmo → desmarca
            if(prev?.diaId === diaId && prev?.hora === hora) {
                return null;
            }

            return { diaId, hora };

        });

        // faz o reagendamento
        if(reagendamento) {

            if(reagendamento.origemDiaId === diaId && reagendamento.origemHora === hora) {
                setErroAcao("não pode reagendar o mesmo dia e horário");
                setReagendamento(null);
                return;
            }

            const diaDestino = semana.find(d => d.firestoreId === diaId);
            const destino = diaDestino?.horas?.[hora];

            if(destino?.status !== "livre") {
                setErroAcao("o novo horário precisa estar livre");
                setReagendamento(null);
                return;
            }

            concluirReagendamento(diaId, hora);
            setReagendamento(null);

        }

    }



    function gerarHorasUI(interval) {

        const horas = [];
        let minutos = 0;

        while (minutos < 24 * 60) {
            const h = String(Math.floor(minutos / 60)).padStart(2, "0");
            const m = String(minutos % 60).padStart(2, "0");
            horas.push(`${h}:${m}`);
            minutos += interval;
        }

        return horas;
    }


    /* operações para alterar o calendário */
    const toggleLivreIndisponivel = async () => {

        //limpa erro anterior
        setErroAcao("");

        //nada selecionado
        if(!selectedSlot) {
            setErroAcao("selecione um dia/horário para executar isso");
            return;
        }

        //trava botão
        setIsUpdating(true);

        try {

            const { diaId, hora } = selectedSlot;

            const diaAtual = semana.find(d => d.firestoreId === diaId);
            const atual = diaAtual?.horas?.[hora];

            if(!atual) {
                throw new Error("Horário não encontrado");
            }

            //ocupado
            if(atual.status === "ocupado") {
                setErroAcao("Esse horário está ocupado.");
                return;
            }

            //define novo status
            const ref = doc(db, "db_calendar", basic.agent.id, "dias", diaId);

            let novoStatus;

            if(atual.status === "livre") {

                novoStatus = "nao_determinado";
                await updateDoc(ref, {[hora]: deleteField()});

            } else {

                novoStatus = "livre";
                await updateDoc(ref, {[hora]: {status: "livre", update_at: null}});

            }

            setSemana(prev => prev.map(dia => {

                if(dia.firestoreId !== diaId) return dia;

                return {
                    ...dia,
                    horas: {
                        ...dia.horas,
                        [hora]: { status: novoStatus }
                    }
                };

            }));

            setErroAcao("troca de disponibilidade realizada com sucesso");

        } catch (e) {
            setErroAcao("Erro ao atualizar.");
        } finally {
            setIsUpdating(false);
        }
    };



    async function criarAgendamento() {

        setErroAcao("");

        if(!selectedSlot) {
            setErroAcao("selecione um dia/horário para executar isso");
            return;
        }

        const { diaId, hora } = selectedSlot;

        const diaAtual = semana.find(d => d.firestoreId === diaId);
        const atual = diaAtual?.horas?.[hora];

        if(!atual) {
            setErroAcao("horário inválido");
            return;
        }

        if(atual.status !== "livre") {
            setErroAcao("o horário precisa estar livre");
            return;
        }

        try {

            let plano = basic.agent.plano;
            let aid = basic.agent.id;

            let tabela = direcionaPlano(plano);

            const contentsref = doc(db, tabela.colecao, aid);
            const contentssnap = await getDoc(contentsref);

            if(contentssnap.empty) {
                throw new Error("Documento não encontrado");
                return;
            }

            const contents = contentssnap.data();

            let exames;
            let convenios;

            switch(plano.slice(0, 3)) {
                case "CMD":
                    exames = contents.exames;
                    convenios = contents.convenios;
                    break;
                default:
                    exames = contents.exames;
                    convenios = [];
                    break;
                }

            setConfigModal({exames, convenios});

            setAtendimento("consulta");
            setValue("nome", "");
            setValue("email", "");
            setValue("telefone", "");
            setValue("pet", "");

            setShowCreateModal(true);

        }
        catch(erro) {
            setErroAcao(erro);
        }

    }



    const salvarAgendamento = async () => {

        formError(refError, "", false);

        const plano = basic.agent.plano;

        const v_nome = (nome) => { let validade = /\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi; return validade.test(nome); }

        let nm = getValues("nome");
        if(!v_nome(nm)) {
            showError(refNome, refLabelNome, refErrorNome, "Insira o nome completo (nome e sobrenome)", setError, "nome");
            return;
        }

        const v_email = (email) => { let validate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; return validate.test(email); }

        let ma = getValues("email");
        if(!v_email(ma)) {
            showError(refEmail, refLabelEmail, refErrorEmail, "Esse email é inválido, verifique a digitação", setError, "email");
            return;
        }

        let tl = getValues("telefone");
        if(tl.length < 15) {
            showError(refTelefone, refLabelTelefone, refErrorEmail, "Telefone inválido, digite o ddd + telefone", setError, "email");
            return;
        }

        // específico para o plano de veterinários
        let pe;
        if(plano.slice(0, 3) === "VET") {
            pe = getValues("pet");
            if(pe.length < 3) {
                showError(refNomePet, refLabelNomePet, refErrorNomePet, "Digite o nome do Pet", setError, "pet");
                return;
            }
        }
        
        try {

            setIsUpdating(true);

            const {diaId, hora} = selectedSlot;

            let telefone = tl;
            telefone = "55" + telefone.replace(/\D/g, "");

            let paciente;

            switch(plano.slice(0, 3)) {
                // médicos
                case "CMD":
                    paciente = {
                        atendimento: novoAgendamento.atendimento === "exame" ? (novoAgendamento.exame || configModal.exames[0]?.exame) : novoAgendamento.atendimento,
                        convenio: novoAgendamento.atendimento === "retorno" ? "particular" : (novoAgendamento.convenio || "particular"),
                        nome: nm,
                        email: ma,
                        telefone: telefone,
                    };
                    break;
                // veterinários
                case "VET":
                    paciente = {
                        atendimento: novoAgendamento.atendimento === "exame" ? (novoAgendamento.exame || configModal.exames[0]?.exame) : novoAgendamento.atendimento,
                        convenio: pe,
                        nome: nm,
                        email: ma,
                        telefone: telefone,
                    };
                    break;
                // dentistas
                case "DET":
                    paciente = {
                        atendimento: novoAgendamento.atendimento === "exame" ? (novoAgendamento.exame || configModal.exames[0]?.exame) : novoAgendamento.atendimento,
                        convenio: null,
                        nome: nm,
                        email: ma,
                        telefone: telefone,
                    };
                    break;

                }
            
            const ref = doc(db, "db_calendar", basic.agent.id, "dias", diaId);

            await updateDoc(ref, {[`${hora}.status`]: "ocupado", [`${hora}.update_at`]: serverTimestamp(), [`${hora}.paciente`]: paciente});

            // atualiza state local
            setSemana(prev =>
                prev.map(dia => {

                    if(dia.firestoreId !== diaId) return dia;

                    return {
                        ...dia,
                        horas: {
                            ...dia.horas,
                            [hora]: {status: "ocupado", update_at: new Date(), paciente}
                        }
                    };

                })
            );

            await addDoc(collection(db, "ls_calendar"), {action: "ADD", id_agent: basic.agent.id, dia: `${diaId.substring(0,4)}-${diaId.substring(4,6)}-${diaId.substring(6,8)}`, hora, nome: paciente.nome, email: paciente.email, telefone: paciente.telefone, atendimento: paciente.atendimento, convenio: paciente.convenio, origem: "plataforma", date: serverTimestamp()});

            setValue("nome", "");
            setValue("email", "");
            setValue("telefone", "");
            setValue("pet", "");

            setShowCreateModal(false);
            setErroAcao("agendamento realizado com sucesso");

        } catch(erro) {
            formError(refError, "Erro: " + erro, true);
        } finally {
            setIsUpdating(false);
        }
        
    };



    const cancelarAgendamento = async () => {

        setErroAcao("");

        if(!selectedSlot) {
            setErroAcao("selecione um dia/horário para executar isso");
            return;
        }

        setIsUpdating(true);

        try {

            const { diaId, hora } = selectedSlot;

            const diaAtual = semana.find(d => d.firestoreId === diaId);
            const atual = diaAtual?.horas?.[hora];

            if(!atual) {
                throw new Error("Horário não encontrado");
            }

            //não está ocupado
            if(atual.status !== "ocupado") {
                setErroAcao("esse horário não possui agendamento");
                return;
            }

            //firestore
            const ref = doc(db, "db_calendar", basic.agent.id, "dias", diaId);

            await updateDoc(ref, {[`${hora}.status`]: "livre", [`${hora}.update_at`]: null, [`${hora}.paciente`]: deleteField()});

            //state
            setSemana(prev => prev.map(dia => {

                if(dia.firestoreId !== diaId) return dia;

                return {...dia, horas: {...dia.horas, [hora]: {status: "livre", update_at: null}}};

            }));

            // registra em calendar_logs
            await addDoc(collection(db, "ls_calendar"), {action: "CANCEL", id_agent: basic.agent.id, dia: `${diaId.substring(0,4)}-${diaId.substring(4,6)}-${diaId.substring(6,8)}`, hora, nome: atual.paciente?.nome || "", email: atual.paciente?.email || "", telefone: atual.paciente?.telefone || "", atendimento: atual.paciente?.atendimento || "", convenio: atual.paciente?.convenio || "", origem: "plataforma", date: serverTimestamp()});

            setErroAcao("cancelamento realizado com sucesso");

        } catch (e) {
            setErroAcao("Erro ao cancelar agendamento.");
        } finally {
            setIsUpdating(false);
        }
    };



    const reAgendamento = async () => {

        setErroAcao("");

        if(!selectedSlot) {
            setErroAcao("selecione um dia/horário para executar isso");
            return;
        }

        setIsUpdating(true);

        try {

            const { diaId, hora } = selectedSlot;

            const diaAtual = semana.find(d => d.firestoreId === diaId);
            const horarioAtual = diaAtual.horas?.[hora];

            if(horarioAtual.status !== "ocupado") {
                setErroAcao("esse horário não possui agendamento");
                return;
            };

            setReagendamento({origemDiaId: diaId, origemHora: hora, paciente: horarioAtual.paciente});

            setErroAcao("agora selecione o dia/horário do reagendamento");

        } catch (e) {
            setErroAcao("Erro ao cancelar agendamento.");
        } finally {
            setIsUpdating(false);
        }
    };



    const concluirReagendamento = async (novoDiaId, novaHora) => {

        setIsUpdating(true);

        try {

            const origemDia = reagendamento.origemDiaId;
            const origemHora = reagendamento.origemHora;
            const paciente = reagendamento.paciente;

            // refs firestore
            const origemRef = doc(db, "db_calendar", basic.agent.id, "dias", origemDia);
            const destinoRef = doc(db, "db_calendar", basic.agent.id, "dias", novoDiaId);

            const batch = writeBatch(db);

            batch.update(origemRef, {[`${origemHora}.status`]: "livre", [`${origemHora}.update_at`]: null, [`${origemHora}.paciente`]: deleteField()});

            batch.update(destinoRef, {[`${novaHora}.status`]: "ocupado", [`${novaHora}.update_at`]: serverTimestamp(), [`${novaHora}.paciente`]: paciente});

            await batch.commit();

            //state
            setSemana(prev => prev.map(dia => {

                if(dia.firestoreId === origemDia) {

                    return {...dia, horas: {...dia.horas, [origemHora]: {status: "livre", update_at: null}}};

                }
                
                if(dia.firestoreId === novoDiaId) {

                    return {...dia, horas: {...dia.horas, [novaHora]: {status: "ocupado", update_at: new Date(), paciente}}};

                }

                return dia;
        
            }));

            //calendar_logs
            await addDoc(collection(db, "ls_calendar"), {action: "CANCEL", id_agent: basic.agent.id, dia: `${origemDia.substring(0,4)}-${origemDia.substring(4,6)}-${origemDia.substring(6,8)}`, hora: origemHora, nome: paciente?.nome || "", email: paciente?.email || "", telefone: paciente?.telefone || "", atendimento: paciente?.atendimento || "", convenio: paciente?.convenio || "", origem: "plataforma", date: serverTimestamp()});
            await addDoc(collection(db, "ls_calendar"), {action: "ADD", id_agent: basic.agent.id, dia: `${novoDiaId.substring(0,4)}-${novoDiaId.substring(4,6)}-${novoDiaId.substring(6,8)}`, hora: novaHora, nome: paciente?.nome || "", email: paciente?.email || "", telefone: paciente?.telefone || "", atendimento: paciente?.atendimento || "", convenio: paciente?.convenio || "", origem: "plataforma", date: serverTimestamp()});

            setErroAcao("reagendamento realizado com sucesso");

        } catch(e) {

            console.log(e);
            setErroAcao("erro ao reagendar");

        } finally {
            setIsUpdating(false);
        }

    };



    function getMensagemAcao() {

        //prioridade máxima: erro
        if(erroAcao) return erroAcao;

        //nada selecionado
        if(!selectedSlot) {
            return "selecione um dia/horário para executar uma ação";
        }

        //selecionado → montar data
        const diaSelecionado = semana.find(d => d.firestoreId === selectedSlot.diaId);

        if(!diaSelecionado) return "";

        //transforma "09.04.2026" → "09/04/26"
        const [dd, mm, yyyy] = diaSelecionado.dia.split(".");
        const yy = yyyy.slice(-2);

        return `selecionado ${dd}.${mm}.${yy} ${selectedSlot.hora}`;
    
    }


    function getCorMensagemAcao(mensagem) {

        if(mensagem.substring(0, 11) === "selecionado") {
            return "var(--PRI_2)";
        } else if(mensagem === "selecione um dia/horário para executar isso" || mensagem === "esse horário não possui agendamento" || mensagem === "não pode reagendar o mesmo dia e horário" || mensagem === "o novo horário precisa estar livre" || mensagem === "o horário precisa estar livre") {
            return "red";
        } else if(mensagem === "troca de disponibilidade realizada com sucesso" || mensagem === "agora selecione o dia/horário do reagendamento"  || mensagem === "cancelamento realizado com sucesso" || mensagem === "reagendamento realizado com sucesso" || mensagem === "agendamento realizado com sucesso") {
            return "green";
        } else {
            return "var(--CNZ_2)";
        }

    }


    function getMensagemNavegar() {

        //prioridade máxima: erro
        if(erroNavegar) return erroNavegar;

        return ;
        
    }

    
    const formatPhone = (telefone) => { if(!telefone) return ""; telefone = telefone.replace(/\D/g, ""); if(telefone.startsWith("55")) { telefone = telefone.substring(2); } return telefone.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");};



    return(
        <div className="context">
        
            <Header access={1}></Header>
        
                <div className="content">
                    
                    <div className="ft_topico">Agenda</div>
                    <div className="ft_descricao">Esse é a sua agenda, aqui você pode visualizar e alterar todos os agendamentos que seus pacientes realizaram.</div>
                    <div className="space"></div>

                    <div className="schedule_filters_box">
                        <div className="schedule_filters_box1">{ isPending ? "carregando ..." : (<>Semana:&nbsp;<span style={{color: "var(--SEC_1)", letterSpacing: "1px"}}>{semana[0]?.dia}</span>&nbsp;a&nbsp;<span style={{color: "var(--SEC_1)", letterSpacing: "1px"}}>{semana[6]?.dia}</span></>) }</div>
                        <div className="schedule_filters_box2">
                            <div className="schedule_filters_box2_box">
                                <div className="schedule_filters_box2_space"></div>
                                <div className="schedule_filters_box2_botao">
                                    <CalendarCheck size={30} color={isUpdating ? "gray" : "orangered"} onClick={isUpdating ? null : toggleLivreIndisponivel} style={{cursor: isUpdating ? "not-allowed" : "pointer"}} />
                                    <span className="schedule_filters_box2_botao_text">{isUpdating ? "..." : "livre/indisp"}</span>
                                </div>
                                <div className="schedule_filters_box2_botao">
                                    <CalendarClock size={30} color="green" onClick={criarAgendamento} style={{cursor: "pointer"}} />
                                    <span className="schedule_filters_box2_botao_text">agendar</span>
                                </div>
                                
                                {showCreateModal && (
                                    <div className="schedule_modal_overlay">
                                        <div className="schedule_modal">
                                            <div className="schedule_modal_title">Novo Agendamento</div>
                                            
                                            {/* formulário para médicos */}
                                            {basic.agent.plano.slice(0, 3) === "CMD" && (
                                            <>
                                            <form className="form">

                                            <div className="schedule_modal_atendimento">
                                                <div className="schedule_modal_group">
                                                    <input type="radio" name="payment" value="consulta" className="radio_custom" checked={atendimento === "consulta"} onChange={handleChange}></input>
                                                    <span className="schedule_modal_text">Consulta</span>
                                                </div>
                                                <div className="schedule_modal_group" style={{justifyContent: "center"}}>
                                                    <input type="radio" name="payment" value="exame" className="radio_custom" checked={atendimento === "exame"} onChange={handleChange}></input>
                                                    <span className="schedule_modal_text">Exame</span>
                                                </div>
                                                <div className="schedule_modal_group" style={{justifyContent: "right"}}>
                                                    <input type="radio" name="payment" value="retorno" className="radio_custom" checked={atendimento === "retorno"} onChange={handleChange}></input>
                                                    <span className="schedule_modal_text">Retorno</span>
                                                </div>
                                            </div>
                                            <span className="space_form"></span>

                                            <div className="inp inp-select">
                                            <select disabled={configModal.exames.length === 0 || atendimento !== "exame"} value={novoAgendamento.exame} onChange={(e) => setNovoAgendamento(prev => ({ ...prev, exame: e.target.value}))}>{configModal.exames.length === 0 ? (<option value="">não realiza exames</option>) : (configModal.exames.map((item) => (<option  key={item.id} value={item.exame}>{item.exame}</option>)))}</select>
                                            <span className="label">Exames</span>
                                                <span className="focus-bg"></span>
                                            </div>
                                            <span className="space_form"></span>

                                            <span ref={refErrorNome} className="error_form"></span>
                                            <label for="inp" className="inp" ref={refLabelNome}>
                                            <input type="text" placeholder="&nbsp;" maxLength={60} {...register("nome")} ref={(el) => {refNome.current = el; register("nome").ref(el);}} onClick={() => clearError(refNome, refLabelNome, refErrorNome, error, setError)} onChange={() => clearError(refNome, refLabelNome, refErrorNome, error, setError)}></input>
                                            <span className="label">Nome Completo</span>
                                            <span className="focus-bg"></span>
                                            </label>
                                            <span className="space_form"></span>

                                            <span ref={refErrorEmail} className="error_form"></span>
                                            <label for="inp" className="inp" ref={refLabelEmail}>
                                            <input type="text" placeholder="&nbsp;" maxLength={40} {...register("email")} ref={(el) => {refEmail.current = el; register("email").ref(el);}} onClick={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onChange={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)}></input>
                                            <span className="label">Email</span>
                                            <span className="focus-bg"></span>
                                            </label>
                                            <span className="space_form"></span>

                                            <span ref={refErrorTelefone} className="error_form"></span>
                                            <label for="inp" className="inp" ref={refLabelTelefone}>
                                            <input type="text" placeholder="&nbsp;" maxLength={15} {...register("telefone")} ref={(el) => {refTelefone.current = el; register("telefone").ref(el);}} onClick={() => clearError(refTelefone, refLabelTelefone, refErrorEmail, error, setError)} onChange={(e) => {if (error === "0") {setValue("telefone", masktelefone(e.target.value));} else {clearError(refTelefone, refLabelTelefone, refErrorEmail, error, setError);}}}></input>
                                            <span className="label">Telefone</span>
                                            <span className="focus-bg"></span>
                                            </label>
                                            <span className="space_form"></span>

                                            <div className="inp inp-select">
                                            <select disabled={configModal.convenios.length === 0 || atendimento === "retorno"} value={novoAgendamento.convenio} onChange={(e) => setNovoAgendamento(prev => ({ ...prev, convenio: e.target.value}))}>
                                            <option value="particular">Particular</option>{configModal.convenios.length > 0 && (configModal.convenios.map((item) => (<option key={item} value={item}>{item}</option>)))}
                                            </select>
                                            <span className="label">Forma de Pagamento</span>
                                                <span className="focus-bg"></span>
                                            </div>
                                            
                                            <span className="space_form"></span>
                                            <span ref={refError} className="error_form"></span>
                                            <span className="space_form"></span>

                                            <div className="schedule_modal_buttons">
                                                <button type="button" className="button2_form" onClick={() => setShowCreateModal(false)}>CANCELAR</button>
                                                <button type="button" className={isUpdating ? "button2_form" : "button_form"} onClick={salvarAgendamento}>{isUpdating ? "AGUARDE ..." : "ADICIONAR"}</button>
                                            </div>
                                            </form>
                                            </>
                                            )}

                                            {/* formulário para dentistas */}
                                            {basic.agent.plano.slice(0, 3) === "DET" && (
                                            <>
                                            <form className="form">
                                                <div className="schedule_modal_atendimento">
                                                    <div className="schedule_modal_groupA">
                                                        <input type="radio" name="payment" value="consulta" className="radio_custom" checked={atendimento === "consulta"} onChange={handleChange}></input>
                                                        <span className="schedule_modal_text">Consulta</span>
                                                    </div>
                                                    <div className="schedule_modal_groupA" style={{justifyContent: "right"}}>
                                                        <input type="radio" name="payment" value="exame" className="radio_custom" checked={atendimento === "exame"} onChange={handleChange}></input>
                                                        <span className="schedule_modal_text">Exame ou Procedimento</span>
                                                    </div>
                                                </div>
                                                <span className="space_form"></span>

                                                <div className="inp inp-select">
                                                    <select disabled={configModal.exames.length === 0 || atendimento !== "exame"} value={novoAgendamento.exame} onChange={(e) => setNovoAgendamento(prev => ({ ...prev, exame: e.target.value}))}>{configModal.exames.length === 0 ? (<option value="">não realiza exames ou procedimentos</option>) : (configModal.exames.map((item) => (<option  key={item.id} value={item.exame}>{item.exame}</option>)))}</select>
                                                    <span className="label">Exames</span>
                                                    <span className="focus-bg"></span>
                                                </div>
                                                <span className="space_form"></span>

                                                <span ref={refErrorNome} className="error_form"></span>
                                                <label for="inp" className="inp" ref={refLabelNome}>
                                                <input type="text" placeholder="&nbsp;" maxLength={60} {...register("nome")} ref={(el) => {refNome.current = el; register("nome").ref(el);}} onClick={() => clearError(refNome, refLabelNome, refErrorNome, error, setError)} onChange={() => clearError(refNome, refLabelNome, refErrorNome, error, setError)}></input>
                                                <span className="label">Nome Completo</span>
                                                <span className="focus-bg"></span>
                                                </label>
                                                <span className="space_form"></span>

                                                <span ref={refErrorEmail} className="error_form"></span>
                                                <label for="inp" className="inp" ref={refLabelEmail}>
                                                <input type="text" placeholder="&nbsp;" maxLength={40} {...register("email")} ref={(el) => {refEmail.current = el; register("email").ref(el);}} onClick={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onChange={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)}></input>
                                                <span className="label">Email</span>
                                                <span className="focus-bg"></span>
                                                </label>
                                                <span className="space_form"></span>

                                                <span ref={refErrorTelefone} className="error_form"></span>
                                                <label for="inp" className="inp" ref={refLabelTelefone}>
                                                <input type="text" placeholder="&nbsp;" maxLength={15} {...register("telefone")} ref={(el) => {refTelefone.current = el; register("telefone").ref(el);}} onClick={() => clearError(refTelefone, refLabelTelefone, refErrorEmail, error, setError)} onChange={(e) => {if (error === "0") {setValue("telefone", masktelefone(e.target.value));} else {clearError(refTelefone, refLabelTelefone, refErrorEmail, error, setError);}}}></input>
                                                <span className="label">Telefone</span>
                                                <span className="focus-bg"></span>
                                                </label>
                                                <span className="space_form"></span>

                                                <div className="schedule_modal_buttons">
                                                    <button type="button" className="button2_form" onClick={() => setShowCreateModal(false)}>CANCELAR</button>
                                                    <button type="button" className={isUpdating ? "button2_form" : "button_form"} onClick={salvarAgendamento}>{isUpdating ? "AGUARDE ..." : "ADICIONAR"}</button>
                                                </div>
                                            </form>
                                            </>
                                            )}

                                        </div>
                                    </div>
                                )}                                

                                <div className="schedule_filters_box2_botao">
                                    <CalendarX size={30} color={isUpdating ? "gray" : "red"} onClick={isUpdating ? null : cancelarAgendamento} style={{cursor: isUpdating ? "not-allowed" : "pointer"}} />
                                    <span className="schedule_filters_box2_botao_text">{isUpdating ? "..." : "cancelar"}</span>
                                </div>
                                <div className="schedule_filters_box2_botao">
                                    <CalendarSync size={30} color="blue" onClick={isUpdating ? null : reAgendamento} style={{cursor: isUpdating ? "not-allowed" : "pointer"}} />
                                    <span className="schedule_filters_box2_botao_text">reagendar</span>
                                </div>
                                <div className="schedule_filters_box2_space"></div>
                            </div>
                            <span className="schedule_filters_box2_erro" style={{color: getCorMensagemAcao(getMensagemAcao())}}>{getMensagemAcao()}</span>
                        </div>
                        <div className="schedule_filters_box3">
                            <div className="schedule_filters_box3_box">
                                <div className="schedule_filters_box3_space"></div>
                                <div className="schedule_filters_box3_botao">
                                    <ArrowBigLeftDash size={30} color={isFirstWeek ? "var(--CNZ_3)" : "orangered"} onClick={() => {if(isFirstWeek) {setErroNavegar("você está na primeira semana"); return;} setErroNavegar(""); semanaAnterior();}} />
                                    <span className="schedule_filters_box2_botao_text">semana anter.</span>
                                </div>
                                <div className="schedule_filters_box3_botao">
                                    <ArrowBigRightDash size={30} color={isLastWeek ? "var(--CNZ_3)" : "orangered"} onClick={() => {if(isLastWeek) {setErroNavegar("você está na última semana"); return;} setErroNavegar(""); proximaSemana();}} />
                                    <span className="schedule_filters_box2_botao_text">prox. semana</span>
                                </div>
                                <div className="schedule_filters_box3_botao">
                                    <ClockArrowUp size={30} color="blue" onClick={() => datePickerRef.current?.setOpen(true)} />
                                    <span className="schedule_filters_box2_botao_text">buscar dia</span>
                                </div>
                                <DatePicker ref={datePickerRef} selected={selectedDate}  onChange={(date) => buscarDia(date)} locale={ptBR} dateFormat="dd/MM/yyyy" calendarStartDay={1} popperPlacement="bottom-end" minDate={mondayStart} maxDate={ mondayEnd ? new Date(mondayEnd.getTime() + 6 * 24 * 60 * 60 * 1000) : null} className="hidden-datepicker" />
                                <div className="schedule_filters_box3_space"></div>
                            </div>
                            <span className="schedule_filters_box3_erro" style={{color: erroNavegar === "você está na primeira semana" || erroNavegar === "você está na última semana" ? "red" : "var(--CNZ_2)" }}>{erroNavegar ? erroNavegar : "navegue pelas semanas"}</span>
                        </div>
                    </div>

                    <div className="schedule_space"></div>

                    <div className="schedule_panel">
                        <div className="schedule_panel_hour">
                            <span className="schedule_panel_hour_title"></span>
                            {HORAS_UI.map(hora => (
                                <span key={hora} className="schedule_panel_hour_item">{hora}</span>
                            ))}
                        </div>
                        <div className="schedule_panel_space"></div>
                        <div className="schedule_panel_content">

                            {isPending ? (<><span className="schedule_loading">aguarde ...<br />carregando agenda</span></>) : 
                            (<>
                            
                            { semana.map((dia, index) => (
                            <div className="schedule_panel_box">
                                <span className="schedule_panel_day" data-short={semana[index]?.dia.substring(0, 5)}>{semana[index]?.dia}</span>
                                <span className="schedule_panel_weekday" data-short={semana[index]?.weekday.substring(0, 3)}>{semana[index]?.weekday}</span>
                                
                                { Object.entries(semana[index]?.horas || {}).map(([hora, info]) => {

                                    const isSelected = selectedSlot?.diaId === semana[index]?.firestoreId && selectedSlot?.hora === hora;
                                    
                                    let bckcolor = "";

                                    if((info.status === "nao_determinado" || info.status === "indisponivel") && semana[index]?.weekday.substring(0, 3) === "Sáb") {
                                        bckcolor = "#f2f6ff";
                                    }
                                    else if((info.status === "nao_determinado" || info.status === "indisponivel") && semana[index]?.weekday.substring(0, 3) === "Dom") {
                                        bckcolor = "#fff2f2";
                                    }
                                    else if((info.status === "nao_determinado" || info.status === "indisponivel") && semana[index]?.weekday.substring(0, 3) !== "Sáb" && semana[index]?.weekday.substring(0, 3) !== "Dom") {
                                        bckcolor = "var(--HEAD_BK)";
                                    }
                                    else if(info.status === "bloqueado") {
                                        bckcolor = "var(--CNZ_4)"
                                    }
                                    else if(info.status === "livre") {
                                        bckcolor = "var(--SEC_4)";
                                    }
                                    else {

                                        const confirmacao = info.paciente?.confirmacao;

                                        if (confirmacao === true) {
                                            bckcolor = "#7FCB8A";
                                        }
                                        else if (confirmacao === false) {
                                            bckcolor = "#E58C8C";
                                        }
                                        else {
                                            // undefined = campo não existe
                                            bckcolor = "#B3C5C8";
                                        }

                                    }

                                    return(
                                    <>
                                    <span className="schedule_panel_hourtohour" onClick={() => selecionarSlot(semana[index]?.firestoreId, hora)} style={{fontSize: info.status === "nao_determinado" || info.status === "indisponivel" || info.status === "bloqueado" ? "0.7rem" : info.status === "livre" ? "1rem" : "0.8rem", backgroundColor: bckcolor, color: info.status === "nao_determinado" || info.status === "indisponivel" ? "var(--CNZ_3)" : info.status === "livre" ? "var(--SEC_1)" : info.status === "bloqueado" ? "var(--BAS_1)" : "var(--PRI_1)", cursor: info.status === "ocupado" ? "pointer" : "default", border: isSelected ? "2px solid #000" : "1px solid transparent", boxSizing: "border-box",}} onMouseEnter={(e) => {

                                        const rect = e.currentTarget.getBoundingClientRect();
                                        const weekday = semana[index]?.weekday;
                                        const ladoEsquerdo = weekday === "Sexta" || weekday === "Sábado" || weekday === "Domingo";

                                        setHoverAgendamento({paciente: info.paciente, hora, dia: semana[index]?.dia, rect, lado: ladoEsquerdo ? "left" : "right"});
                                    
                                    }} data-short={info.status === "nao_determinado" || info.status === "indisponivel" ? "-" : info.status === "livre" || info.status === "bloqueado" ? "livre" : "ver"}>{info.status === "nao_determinado" || info.status === "indisponivel" ? "não disponível" : info.status === "livre" || info.status === "bloqueado" ? info.status : info.paciente?.nome || ""}</span>
                                    </>
                                    ); 
                                })}

                            </div>
                            ))}

                            </>)}

                        </div>
                    </div>

                    {hoverAgendamento?.paciente && (<TooltipAgendamento data={hoverAgendamento} tooltipRef={tooltipRef}/>)}

                    <div className="schedule_legends_group">
                        <div className="schedule_legends_space"></div>
                        <div className="schedule_legends_content">
                            <span className="schedule_legends_title">Legenda:</span>
                            <div className="schedule_legends_box">
                                <span className="schedule_legends_color" style={{backgroundColor: "#B3C5C8"}}></span>
                                <span className="schedule_legends_text">paciente não respondeu a confirmação</span>
                            </div>
                            <div className="schedule_legends_box">
                                <span className="schedule_legends_color" style={{backgroundColor: "#7FCB8A"}}></span>
                                <span className="schedule_legends_text">paciente confirmou</span>
                            </div>
                            <div className="schedule_legends_box">
                                <span className="schedule_legends_color" style={{backgroundColor: "#E58C8C"}}></span>
                                <span className="schedule_legends_text">paciente não poderá ir</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="space"></div>
                    <span className="schedule_observacao">Obs.: Para alterar de forma massiva e mais prática as disponibilidades e indisponibilidades de dias/horários, você pode acessar:<br />Painel do Cliente &#8594; Alterar Agente &#8594; Alterar Configurações &#8594; Passo 4 - Calendário</span>
                    <div className="space_form"></div>
                    <span className="schedule_observacao">ou</span>
                    <div className="space_form"></div>
                    <Link className="schedule_link_agenda" to="/medical" state={{step: 3}}>ALTERAR AGENDA</Link>

                <div className="space"></div>
                <div className="space"></div>
                <div className="button_back_form"><button type="button" name="btbck" className="button2_form" onClick={() => navigate("/panel")}>VOLTAR</button></div>
                <div className="space"></div>
                <div className="space"></div>
                        
                </div>
                        
            <Footer access={1}></Footer>
                        
        </div>
    )
}